import { CivilStatusRepository } from "../repositories/CivilStatus.repository";

export const CivilStatusService = {
    getCivilStatus,
}

async function getCivilStatus(){
    const res = await CivilStatusRepository.getCivilStatus();
    return res;
}